module.exports = __webpack_public_path__ + "static/pic_filmstill_koester_detmold1937_04.8dd2eadd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/pic_filmstill_koester_detmold1937_04.jpg
// module id = 508
// module chunks = 142966368958528